import React from 'react';
import {
  Box, Typography, Grid, TextField, InputAdornment
} from '@mui/material';
import {
  Facebook, Twitter, LinkedIn, Instagram, People
} from '@mui/icons-material';

const SocialMediaStep = ({ formik, textFieldStyles, socialMediaPlatforms }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#f9f9f9',
        padding: '30px',
        borderRadius: '12px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        maxWidth: '800px',
        margin: 'auto'
      }}
    >
      <Typography
        variant='h5'
        gutterBottom
        sx={{
          color: '#1976d2',
          textAlign: 'center',
          mb: 3,
          fontWeight: 'bold'
        }}
      >
        <People sx={{ verticalAlign: 'middle', mr: 1 }} />
        Social Media Links
      </Typography>

      <Grid container spacing={2}>
        {socialMediaPlatforms.map(({ name, label, icon }) => (
          <Grid item xs={12} sm={6} key={name}>
            <TextField
              name={`social_media.${name}`}
              label={label}
              fullWidth
              onChange={formik.handleChange}
              value={formik.values.social_media?.[name] || ''}
              sx={textFieldStyles}
              InputProps={{
                startAdornment: <InputAdornment position='start'>{icon}</InputAdornment>
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default SocialMediaStep;
